function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_366",
  "data-name": "Group 366",
  transform: "translate(-0.625 0.375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_157",
  "data-name": "Group 157",
  transform: "translate(0 6.14)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_156",
  "data-name": "Group 156",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M323.45,73.739",
  transform: "translate(-317.528 -73.739)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x1: 3.761,
  transform: "translate(2.372 2.113)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_14",
  "data-name": "Line 14",
  x1: 2.42,
  transform: "translate(3.442)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_16",
  "data-name": "Line 16",
  x1: 0.926,
  transform: "translate(1)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M332.612,43.986v-.811a.779.779,0,0,1,.777-.776h1.5a.779.779,0,0,1,.777.776v.811",
  transform: "translate(-324.895 -42.399)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M357.214,53.009a6.09,6.09,0,0,1,1.454,1.326",
  transform: "translate(-344.677 -50.93)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_18",
  "data-name": "Line 18",
  y2: 1.294,
  transform: "translate(9.244 1.076)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M332.51,61.721a3.377,3.377,0,1,1-1.923,6.152",
  transform: "translate(-323.267 -57.935)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M316.614,57.252a4.831,4.831,0,1,1-.261,2.945",
  transform: "translate(-311.822 -51.97)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M315.756,74.928q-.006-.126-.006-.254a4.846,4.846,0,0,1,.113-1.044",
  transform: "translate(-311.337 -67.511)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M337.636,75.3a.891.891,0,1,1-.891-.892A.891.891,0,0,1,337.636,75.3Z",
  transform: "translate(-327.501 -68.134)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_19",
  "data-name": "Line 19",
  y1: 0.6,
  x2: 0.744,
  transform: "translate(9.99 6.018)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_20",
  "data-name": "Line 20",
  y1: 1.701,
  x2: 2.112,
  transform: "translate(6.474 7.748)",
  fill: "none",
  stroke: "#9b9eb9",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}));

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.823,
    height: 12.742,
    viewBox: "0 0 13.823 12.742",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.ef4f2b31.svg";
export { ForwardRef as ReactComponent };